import React from "react";
import { useUserContext } from "context/UserContext";
import MembershipManagementBK from "layouts/BK/membershipManagement";
import { isManagementRoleLevel, normalizeRoleLevel } from "utils/roleUtils";

function MembershipManagement() {
  const { roleLevel } = useUserContext() || {};
  if (isManagementRoleLevel(normalizeRoleLevel(roleLevel))) {
    return <MembershipManagementBK />;
  }
  return null;
}

export default MembershipManagement;
